import { Pipe, PipeTransform } from '@angular/core';
import { AvailableUsersModel } from 'src/app/lobby/lobby-staff-status/shared/models/impersonate-assist-detail.model';

@Pipe({
    name: 'impersonationtransferselectdisable',
    pure: false
})
export class ImpersonationTransferSelectDisablePipe implements PipeTransform {
    transform(items: AvailableUsersModel[], impersonatedByUserId: number): boolean {
        if (!items) {
            return false;
        }
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        return items.filter(item => item.availableImpersonateAssistCount > 0 || item.userId == impersonatedByUserId).length > 0;
    }
}